import {
  Select as OdSelect,
  SelectProps as BaseSelectProps,
} from '@overdose/components'
import classNames from 'classnames'
import { Icon } from '../Icon'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './Select.module.css'

interface SelectProps extends BaseSelectProps {
  error?: string
}

const Select = ({ label, name, error, disabled, ...props }: SelectProps) => {
  return (
    <div>
      {label && (
        <label htmlFor={`${name}_select`} className='inline-block mb-2'>
          <Typography
            tag={TypographyTag.span}
            variant={TypographyVariant.BodySmallBold}
            className={classNames('inline-block text-primary-heading', {
              [styles.disabledLabel]: props.disabled,
            })}>
            {label}
            {props.required && '*'}
          </Typography>
        </label>
      )}
      <OdSelect
        name={name}
        disabled={disabled}
        theme={{
          list: styles.list,
        }}
        {...props}
        validationStatus={error ? 'error' : undefined}
      />
      {error && (
        <div className='flex gap-4 mt-4 items-center'>
          <Icon
            iconName='alert-triangle-filled'
            size={16}
            color='var(--color-state-alert)'
          />

          <Typography
            tag={TypographyTag.p}
            variant={TypographyVariant.BodySmallBold}
            className='text-alert'>
            {error}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default Select
